
export enum AllocationPlanType {
    AnnualAllocation = 1,
    ShortRoundAllocation = 2,
}